export default "__VITE_ASSET__1ce1c703__"